<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('graduate_exam_results')" :isNewButton="checkPermission('graduateapplicationevaluationexam_store')" :isFilter="false"
                        @new-button-click="createFormShow()" :is-import-button="checkPermission('graduateapplicationevaluationexam_excelimport')" @import-button-click="importData"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('graduate_exam_results')" :isNewButton="checkPermission('graduateapplicationevaluationexam_store')" :isFilter="false"
                              @new-button-click="createFormShow()" :is-import-button="checkPermission('graduateapplicationevaluationexam_excelimport')" @import-button-click="importData"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear" :other-button="studentExamData" @studentExcel="getStudentExamData">
                <b-row>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="datatable.queryParams.filter.program_code" :faculty_code="34" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('evaluation_type')">
                            <evaluation-exam-definition-selectbox v-model="datatable.queryParams.filter.evaluation_exam_definition_id" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('national_id')">
                            <b-form-input v-model="datatable.queryParams.filter.national_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="datatable.queryParams.filter.surname" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('score')">
                            <b-form-input v-model="datatable.queryParams.filter.score"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
                       @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'" />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId" @updateFormSuccess="updateFormSuccess" v-if="formProcess == 'update'" />
                </template>
            </CommonModal>
            <CommonModal ref="importFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('graduate_exam_results').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <import-form @successProcess="importFormSuccess" v-if="formProcess == 'import'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import EvaluationExamDefinitionSelectbox from "@/components/interactive-fields/EvaluationExamDefinitionSelectbox.vue";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";

// Pages
import CreateForm from "./CreateForm";
import UpdateForm from "./UpdateForm.vue";
import ImportForm from "./ImportExcel"

// Services
import GraduateApplicationEvaluationExamsService from "@/services/GraduateApplicationEvaluationExamsService";
import ConstantService from '@/services/ConstantService';

// Others
import qs from 'qs'

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        CommonModal,
        CreateForm,
        UpdateForm,
        ImportForm,
        EvaluationExamDefinitionSelectbox,
        ProgramSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('graduate_exam_results')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('edit'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "graduateapplicationevaluationexam_update",
                                callback: (row) => {
                                    this.updateFormShow(row.id)
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "graduateapplicationevaluationexam_delete",
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('program'),
                        field: 'graduate_application.program',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('evaluation_type'),
                        field: 'evaluation_exam_definition_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('national_id'),
                        field: 'graduate_application.national_id',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('student'),
                        field: 'graduate_application_id',
                        formatFn: (value, row) => {
                            return (row.graduate_application.name + " " + row.graduate_application.surname);
                        },
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('score'),
                        field: 'score',
                        hidden: false,
                    }

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
            selectedProgramCode: null,
            formProcess: null,
            formId: null,
            form: {},
            semesterId: null,
        }
    },
    computed: {
      studentExamData() {
        return {
          title: this.$t('student_exam_data'),
          show: this.checkPermission('graduateapplicationevaluationexam_excelexport'),
          emit: 'studentExcel'
        }
      }
    },
    created() {
        this.filterSet();
        this.formClear();
        this.getGraduateApplicationSemester();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {
                id: null,
                evaluation_exam_definition_id: null,
                graduate_application_id: null,
                score: null,
                // national_id: null,
                // program: null
            }
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            return GraduateApplicationEvaluationExamsService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total

                    this.datatable.rows.forEach((c) => c.status = c.status == 'a' ? this.$t('active') : this.$t('passive'))
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },

        // Create
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.createFormModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },

        // Update
        updateFormShow(id) {
            this.formId = id
            this.formProcess = 'update'
            this.$refs.updateFormModal.$refs.commonModal.show()
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },

        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        GraduateApplicationEvaluationExamsService.del(id)
                            .then(response => {
                                this.$toast.success(this.$t(response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t(error.data.message));
                            });
                    }
                })
        },

        exportExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return GraduateApplicationEvaluationExamsService.exportExcel(config)
                .then((response) => {
                    this._downloadFile(response, 'graduate_exam_results.xlsx')
                })
                .catch(e => {
                    this.showErrors(e, this.$refs.formValidate)
                });
        },
        importData() {
            this.formProcess = 'import'
            this.$refs.importFormModal.$refs.commonModal.show()
        },
        importFormSuccess() {
            this.formProcess = null;
            this.$refs.importFormModal.$refs.commonModal.hide()
        },
        getGraduateApplicationSemester(){
          const config = {
            params: {
              key:'graduate_application.semester_id'
            },
            paramsSerializer: (params) => qs.stringify(params, {encode: false})
          };
          ConstantService.getValue(config)
              .then(response=>{
                this.semesterId = response.data.data
              }).catch(err=>{
            this.showErrors(err)
          })
        },
        getStudentExamData() {
          if (this.checkPermission('graduateapplicationevaluationexam_excelexport')) {
            GraduateApplicationEvaluationExamsService.studentExam(this.semesterId)
                .then((response) => {
                  this.$toast.success(this.$t('api.' + response.data.message))
                })
                .catch((error) => {
                  this.showErrors(error)
                })
          } else {
            this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
          }
        }
    }
}
</script>
